'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var stringEndsWith = {};

exports.__exports = stringEndsWith;
